<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="TradeUnitId"
      ref="list"
      unit="用户"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="multiple"
      :show-query="true"
      :query-params="params"
      :get-data-func="api.list"
      urlHash="basedata/business/come"
      :showTrendTable="showTrendTable"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
export default {
  mixins: [listMixin],
  components: { list },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  data() {
    return {
      api: require("@/api/ba/tradeUnit").default,
      // api: require("@/api/ba/tradeUnit").default,
      params: {
        TradeUnitNo: "",
        FullName: "",
        TradeUnitType: null,
        TradeUnitTypes: null,
        DpId: null,
        EmpId: null,
        CreatedDate: "",
      },
    };
  },
  props: {
    showTrendTable: {
      type: Boolean,
      default: true,
    },
    modelType: {
      type: String,
      default: "",
    },
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    //
    // getFormData() {
    //   let modeName = this.modelType
    //     ? this.modelType
    //     : location.hash.split("/").slice(1).join("");
    //   this.formApi.list({ type: modeName }).then((res) => {
    //     if (res.Data === null || res.Data.length === 0) return;
    //     if (res.Code == 0) {
    //       const ShowField = res.Data.map((x) => x.ShowField);
    //       this.fromData.map((item) => {
    //         item.show = ShowField.indexOf(item.field) !== -1 ? true : false;
    //       });
    //     }
    //   });
    // },

    onExport(data) {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      var params = { ...this.params, IdChain: data.IdChain };
      this.api.export(params).then(() => {
        loading.close();
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
